var lib_core = require("lib-core");

var ProcessMessageStateMachine = function (root, model) {
    var self = this;

    this.root = root;
    this.model = model;

    lib_core.StateMachine.call(self, null, null, this.model.scope());

    // should not be using this.  loading is not a user action.

    // self.addTransition("idle", "loading",
    //     function(cEvent){
    //         return self.model.visible();
    //     },

    //     function(cEvent){}
    // );

    // self.addTransition("loading", "idle",
    //     function(cEvent){
    //         return !self.model.visible();
    //     },

    //     function(cEvent){}
    // );
};

lib_core.inherit(ProcessMessageStateMachine, lib_core.StateMachine);

module.exports = ProcessMessageStateMachine;
